<template>
  <div>
    <template v-if="loading">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <CompanyRatingsHeader
        :name="company.name"
        :status="company.status.name"
      />
      <Rating
        :rating="company.rating"
        :rating-number="company.rating_number"
        :rating-percentages="ratingPercentages"
      />
      <CompanyRatingsList />
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import CompanyRatingsHeader from './CompanyRatingsHeader';
import Rating from './Rating';
import CompanyRatingsList from './CompanyRatingsList';

export default {
  components: {
    CompanyRatingsHeader,
    CompanyRatingsList,
    Rating,
  },
  data: () => ({
    loading: true,
    company: {},
    ratings: [],
    ratingPercentages: [
      {
        id: 5,
        value: 0,
      },
      {
        id: 4,
        value: 0,
      },
      {
        id: 3,
        value: 0,
      },
      {
        id: 2,
        value: 0,
      },
      {
        id: 1,
        value: 0,
      },
    ],
  }),
  mounted() {
    this.getCompany();
  },
  methods: {
    getCompany() {
      this.loading = true;
      axios
        .get(`companies/${this.$route.params.id}`)
        .then(res => {
          this.company = res.data.data;
          this.company.rating_percentages.forEach(element => {
            const per = this.ratingPercentages.filter(obj => {
              return obj.id === element.rating;
            });
            // eslint-disable-next-line radix
            per[0].value = parseInt(element.percentage);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/ratings/CompanyRatings.vue